import { Pressable, type PressableProps } from "react-native";
import type { ReactNode } from "react";

interface ScalePressableProps {
  children?: ReactNode;
  onPress?: () => void;
  enabled?: boolean;
  disabled?: boolean;
  style?: PressableProps["style"];
  hitSlop?: PressableProps["hitSlop"];
}

export function ScalePressable({ children, onPress, enabled, disabled, style, hitSlop }: ScalePressableProps) {
  const isDisabled = disabled ?? (enabled !== undefined ? !enabled : false);
  return (
    <Pressable onPress={onPress} disabled={isDisabled} style={style} hitSlop={hitSlop}>
      {children}
    </Pressable>
  );
}
